import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  rootSectionTitle: {
    borderBottom: '3px solid #B9BEBE',
    paddingBottom: '25px',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      display: 'block',
      borderBottom: 'solid 3px #cd0021',
      bottom: '-3px',
      width: '100px',
      [theme.breakpoints.down('sm')]: {
        width: '50px',
        borderBottom: 'solid 2px #cd0021',
        bottom: '-2px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '15px',
      borderBottom: '2px solid #B9BEBE',
    },
  },
  sectionTitle: {
    fontFamily: 'Noto Sans JP',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '30px',
    lineHeight: '45px',
    letterSpacing: '0.8px',
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      lineHeight: '30px',
      letterSpacing: '0.28px',
    },
  },
}));

export default useStyles;
